/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctorAvailability } from 'app/shared/model/doctor-availability.model';

export interface IDoctorAvailabilitySlot {
  id?: string;
  timestampEntry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  startTime?: number | null;
  endTime?: number | null;
  availability?: IDoctorAvailability | null;
}

export const defaultValue: Readonly<IDoctorAvailabilitySlot> = {
  active: false,
};
